import { useState } from "react";
import { Button } from "primereact/button";
import {
  ExtractAnswerOptionsValues,
  TargetQuestionTypeValues,
} from "../../../../utils/constants";
import { Dropdown } from "primereact/dropdown";

export const ExtractAnswerOptions = [
  {
    name: "Selected Option",
    value: ExtractAnswerOptionsValues?.selectedOption,
  },
  {
    name: "Non Selected Options",
    value: ExtractAnswerOptionsValues?.nonSelectedOptions,
  },
  { name: "All Options", value: ExtractAnswerOptionsValues?.allOptions },
];

export const TargetQuestionType = [
  { name: "Single Select", value: TargetQuestionTypeValues?.singleSelect },
  { name: "Multi-Select", value: TargetQuestionTypeValues?.multiSelect },
  { name: "Ranking", value: TargetQuestionTypeValues?.ranking },
];

const ExtractionLogic = ({
  isSLDialogVisible,
  setIsSLDialogVisible,
  setSelectedTQIndex,
  handleSaveExtractionLogic,
  isExtractionQuestion,
  selectedTQ,
}) => {
  const [selectedExtractedAnsOpt, setSelectedExtractedAnsOpt] = useState(
    isExtractionQuestion
      ? selectedTQ?.selectedExtractedAnsOpt
      : ExtractAnswerOptionsValues?.selectedOption,
  );
  const [selectedTargetQuesType, setSelectedTargetQuesType] = useState(
    isExtractionQuestion
      ? selectedTQ?.selectedTargetQuesType
      : TargetQuestionTypeValues?.singleSelect,
  );

  const onSaveClick = () => {
    let selectedExtractedOptions = {
      selectedTargetQuesType: selectedTargetQuesType,
      selectedExtractedAnsOpt: selectedExtractedAnsOpt,
    };
    handleSaveExtractionLogic(selectedExtractedOptions, isExtractionQuestion);
  };

  return (
    <div>
      <div className="note-text fs-14 mt-1">
        Takes the specific options a participant selected in a previous question
        and uses them as the answer choices in a new question
      </div>
      <div className="m-0 pt-4">
        <div className="mt-4 py-3" style={{ backgroundColor: "#f5f5f5" }}>
          <div className="row px-3">
            <div className="col-md-6 col-12 mb-1">
              <label>Which answers do you want to extract:</label>
              <Dropdown
                value={selectedExtractedAnsOpt}
                onChange={(e) => {
                  setSelectedExtractedAnsOpt(e.value);
                }}
                options={ExtractAnswerOptions}
                optionLabel="name"
                placeholder="Extract Answer Options"
                className="w-100 inputField"
              />
            </div>
            <div className="col-md-6 col-12 mb-1">
              <label>Choose target question type:</label>
              <Dropdown
                value={selectedTargetQuesType}
                onChange={(e) => {
                  setSelectedTargetQuesType(e.value);
                }}
                options={TargetQuestionType}
                optionLabel="name"
                placeholder="Target Question Type"
                className="w-100 inputField"
              />
            </div>
          </div>

          <div className="p-1">
            <div className="bg-white p-3 mt-3 fw-600">
              The extracted question type will be automatically added
            </div>
          </div>
        </div>
      </div>

      <div className="d-flex justify-content-end gap-2 mt-4">
        <Button
          label="Cancel"
          className="px-4 py-2 fw-bold cancel"
          onClick={() => {
            if (!isSLDialogVisible) return;
            setIsSLDialogVisible(false);
            setSelectedTQIndex(null);
          }}
        />

        <Button
          label="Save Logic"
          className="px-4 py-2 fw-bold createClientBtn d-flex align-items-center"
          onClick={onSaveClick}
        />
      </div>
    </div>
  );
};

export default ExtractionLogic;
